/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { useTodaysFixturesWC26, useWC26UserTeams } from '../../queries';
import Spinner from '../Spinner/Spinner';
import FixtureCardWC26 from './FixtureCardWC26';
import './FixturesOfTheDayWC26.css';

const TOURNAMENT_START = '2026-06-11';
const TOURNAMENT_END = '2026-07-19';

const TOURNAMENT_DATES = (() => {
  const dates: string[] = [];
  const current = new Date(TOURNAMENT_START);
  const end = new Date(TOURNAMENT_END);
  while (current <= end) {
    dates.push(current.toISOString().split('T')[0]);
    current.setDate(current.getDate() + 1);
  }
  return dates;
})();

function FixturesOfTheDayWC26() {
  const today = new Date().toISOString().split('T')[0];
  const defaultDate = today < TOURNAMENT_START
    ? TOURNAMENT_START
    : today > TOURNAMENT_END ? TOURNAMENT_END : today;

  const [selectedDate, setSelectedDate] = useState(defaultDate);

  const dateIndex = TOURNAMENT_DATES.indexOf(selectedDate);
  const canGoPrev = dateIndex > 0;
  const canGoNext = dateIndex < TOURNAMENT_DATES.length - 1;

  const [fixturesLoading, fixtures, fixturesError] = useTodaysFixturesWC26(selectedDate);
  const [teamAllocationsLoading, teamAllocations, teamAllocationsError] = useWC26UserTeams();
  const loading = fixturesLoading || teamAllocationsLoading;
  const error = fixturesError || teamAllocationsError;

  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const timeUntilNextUpdate = (10 - (minutes % 10)) * 60;
      setCountdown(timeUntilNextUpdate - seconds);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60);
    const seconds = Math.floor(countdown % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const isToday = selectedDate === defaultDate;

  return (
    <div className="fixtures-wc26-container">
      <h2>Fixtures</h2>
      <div className="fixtures-wc26-countdown">
        {`Next update in ${formatCountdown()}`}
      </div>
      <div className="fixtures-wc26-date-nav">
        <button
          type="button"
          className="fixtures-wc26-nav-btn"
          onClick={() => setSelectedDate(TOURNAMENT_DATES[dateIndex - 1])}
          disabled={!canGoPrev}
          aria-label="Previous day"
        >
          ‹
        </button>
        <select
          className="fixtures-wc26-date-select"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        >
          {TOURNAMENT_DATES.map((date) => (
            <option key={date} value={date}>
              {date === today ? 'Today' : new Date(date).toLocaleDateString(undefined, {
                weekday: 'short', month: 'short', day: 'numeric',
              })}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="fixtures-wc26-nav-btn"
          onClick={() => setSelectedDate(TOURNAMENT_DATES[dateIndex + 1])}
          disabled={!canGoNext}
          aria-label="Next day"
        >
          ›
        </button>
      </div>
      {!isToday && (
        <button
          type="button"
          className="fixtures-wc26-today-btn"
          onClick={() => setSelectedDate(defaultDate)}
        >
          Back to today
        </button>
      )}
      {error ? <p className="fixtures-wc26-empty">Failed to load fixtures.</p>
        : loading ? <Spinner />
          : !fixtures || fixtures.length === 0
            ? <p className="fixtures-wc26-empty">No fixtures today</p>
            : fixtures.map((fixture) => (
              <FixtureCardWC26
                key={fixture.id}
                fixture={fixture}
                teamAllocs={teamAllocations ?? []}
              />
            ))}
    </div>
  );
}

export default FixturesOfTheDayWC26;
